import {
  Box,
  Collapse,
  Flex,
  Icon,
  IconButton,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import { AiOutlineClose } from "@onemind-services-llc/react-icons-ng/ai";
import { GiHamburgerMenu } from "@onemind-services-llc/react-icons-ng/gi";
import Logo from "public/brand/logo.webp";
import { DesktopNav } from "./components/DesktopNav";
import { MobileNav } from "./components/MobileNav";
import Link from "next/link";
import Image from "next/image";
import SafeView from "../safeView";

const Header = () => {
  const headerBackground = useColorModeValue("white", "gray.800");
  const headerColor = useColorModeValue("gray.600", "white");
  const { isOpen, onToggle } = useDisclosure();
  return (
    <Box
      position="fixed"
      top={0}
      width={"100%"}
      zIndex={10}
      borderBottom={1}
      bgColor={"white"}
      borderStyle={"solid"}
      borderColor={useColorModeValue("gray.200", "gray.900")}
    >
      <SafeView>
        <Flex
          width={"100%"}
          maxW={"10xl"}
          bg={headerBackground}
          color={headerColor}
          minH={"93px"}
          align={"center"}
          justifyContent="space-between"
          paddingY={"min(2%, 0.5rem)"}
        >
          <Link href={"/"}>
            <Image alt="logo" src={Logo} style={{ width: "169px" }} priority />
          </Link>
          <Flex display={{ base: "flex", md: "none" }}>
            <IconButton
              onClick={onToggle}
              icon={
                isOpen ? (
                  <Icon as={AiOutlineClose} w={3} h={3} />
                ) : (
                  <Icon as={GiHamburgerMenu} w={5} h={5} />
                )
              }
              variant={"ghost"}
              title={"Hamburger"}
              aria-label={"Toggle Navigation"}
            />
          </Flex>
          <Flex display={{ base: "none", md: "flex" }}>
            <DesktopNav />
          </Flex>
        </Flex>
      </SafeView>
      <Collapse in={isOpen} animateOpacity>
        <MobileNav />
      </Collapse>
    </Box>
  );
};

export default Header;
